<header>
  <div class="header">
    <div class="header__bar">
      <div class="header__bar-menu hide-desktop" (click)="openMenu()" appClickOutside (clickOutside)="clickedOutside()">
        <span class="icon" [ngClass]="{ 'icon-Menu': !isMenuOpen, 'icon-Cross': isMenuOpen }"></span>
        <ul [ngClass]="{ visible: isMenuOpen }">
          <li>
            <div class="label-btn" (click)="openProfileCard()">
              <img src="../../../../../assets/images/landing/thinking.webp" alt="Thinking" width="21" height="21" />
              {{ 'landing.button.why_you_need_it' | translate }}
            </div>
          </li>
          <li>
            <div class="label-btn" routerLink="/how-to-guide">
              <img src="../../../../../assets/images/landing/how-to.webp" alt="How To Guide" width="21" height="21" />
              {{ 'general.how_to_guide' | translate }}
            </div>
          </li>
          <li>
            <app-language-picker [isMobileMenu]="true" [isNameShort]="false"></app-language-picker>
          </li>
        </ul>
      </div>

      <img class="header__bar-logo" routerLink="/" src="../../../../assets/images/workflow.svg" alt="WorkFlow" width="122" height="20" />
      <div class="label-btn hide-mobile" (click)="openProfileCard()">
        <img src="../../../../../assets/images/landing/thinking.webp" alt="Thinking" width="21" height="21" />
        {{ 'landing.button.why_you_need_it' | translate }}
      </div>
      <div class="label-btn hide-mobile" routerLink="/how-to-guide">
        <img src="../../../../../assets/images/landing/how-to.webp" alt="How To Guide" width="21" height="21" />
        {{ 'general.how_to_guide' | translate }}
      </div>
    </div>
    <div class="header__nav">
      <app-language-picker class="hide-mobile" [isTitleVisible]="false" [isNameVisible]="false"></app-language-picker>
      <div class="start-btn" routerLink="auth/login/">{{ 'landing.button.start_trial' | translate }}</div>
    </div>
  </div>
</header>
